import React, { useState, useRef } from "react"
import styled, { css } from "styled-components"
import { media, breakpoints } from "src/styles/breakpoints"
import useScrollListener from "src/hooks/useScrollListener"
import ResourcesSearchForm from "src/components/ResourcesSearchForm"

const ResourcesSearchBar = () => {
  const [fixed, setFixed] = useState(false)
  const wrapper = useRef()

  function canMove() {
    return (
      typeof window !== "undefined" && window.innerWidth > breakpoints.desktop
    )
  }

  function handleScroll() {
    if (canMove()) {
      const heroHeight = Math.min(window.innerHeight, window.innerWidth * 0.7)
      const heroScrollProgress = Math.min(window.scrollY / heroHeight, 1)
      const offset = parseInt(160 * heroScrollProgress)
      setFixed(heroScrollProgress === 1)
      wrapper.current.style.transform = `translateY(${offset}px)`
    }
  }

  useScrollListener({
    callback: handleScroll,
  })

  return (
    <Wrapper ref={wrapper} fixed={fixed}>
      <ResourcesSearchForm placeholder="Search for resources…" />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: calc(100vw - ${(p) => p.theme.sidePadding.phone * 2}px);
  align-self: center;
  margin-top: 50px;
  position: relative;
  z-index: 3;
  transition: 0.25s ${(p) => p.theme.easing.easeOutQuad};
  transition-property: visibility, opacity;

  ${media.tablet} {
    max-width: none;
    margin-top: 100px;

    ${(p) =>
      p.fixed &&
      css`
        max-width: 490px;
        margin: 0 auto;
        position: fixed;
        right: 0;
        top: -160px;
        left: 0;

        header.-visible + main & {
          visibility: hidden;
          opacity: 0;
        }
      `}
  }
`

export default ResourcesSearchBar
